export default "__VITE_ASSET__IZZxbMak__"